module.exports = __webpack_public_path__ + "img/addImage.1b860059.jpg";